export const translations = {
  en: {
    // Navigation
    nav_about: "About",
    nav_services: "Services",
    nav_team: "Team",
    nav_portfolio: "Portfolio",
    nav_contact: "Contact",
    nav_contact_us: "Contact Us",
    // Hero
    hero_label: "Insolvency Services & Consulting",
    hero_h1_1: "Insolvency",
    hero_h1_2: "Expertise &",
    hero_h1_3: "Trusted Solutions",
    hero_sub: "For over a decade, ENSO SPRL has been the trusted partner of companies facing financial difficulties, providing transparent and efficient management of insolvency procedures.",
    hero_cta_services: "Our Services",
    hero_cta_contact: "Get in Touch",
    hero_stat_years: "Years of Experience",
    hero_stat_cases: "Cases Managed",
    hero_stat_offices: "Office Locations",
    hero_scroll: "Scroll",
    // About
    about_label: "About Us",
    about_h2_1: "Over a Decade of",
    about_h2_2: "Trusted Practice",
    about_text: "ENSO SPRL is a limited liability professional company, established according to the provisions of GEO no. 86/2006, with the sole object of activity being the practice of insolvency practitioners.",
    about_extended: "With over 15 years of experience in insolvency, ENSO SPRL has successfully managed more than 1,500 cases nationwide. Our multidisciplinary team, with extensive expertise in preventive conciliation, judicial reorganization, and bankruptcy procedures, allows us to provide clients with efficient and personalized solutions, adapted to the specifics of each case.",
    about_detail: "Our activity covers numerous business sectors, and we have a solid presence in the country's main economic centers. We have developed over time a series of mechanisms and processes applicable in insolvency, tailored and grafted onto the specifics of each company.",
    about_founders: "Founding Partners",
    about_formerly: "Formerly at",
    // Services
    services_label: "Our Services",
    services_h2_1: "Comprehensive Insolvency",
    services_h2_2: "Solutions",
    services_sub: "We provide a full range of insolvency services, from preventive measures to complete liquidation procedures.",
    // Stats
    stats_label: "Key Metrics",
    stats_h2: "Advantages for",
    stats_h2_gold: "Creditors",
    // Team
    team_label: "Our Team",
    team_h2_1: "A Multidisciplinary",
    team_h2_2: "Team of Experts",
    team_sub: "Our team combines decades of experience across insolvency practice, law, accounting, and technology.",
    team_tab_practitioners: "Insolvency Practitioners",
    team_tab_lawyers: "Lawyers & Jurists",
    team_tab_support: "Support Staff",
    team_note: "The professional company also has secretarial and document processing staff for maintaining internal documentation records.",
    // Portfolio
    portfolio_label: "Portfolio",
    portfolio_h2_1: "High-Profile Cases",
    portfolio_h2_2: "Successfully Managed",
    portfolio_sub: "Debtors with a high degree of difficulty, handled with expertise and precision to maximize creditor recovery.",
    portfolio_debts: "Debts",
    portfolio_assets: "Assets",
    // Objectives
    objectives_label: "Our Approach",
    objectives_h2_1: "Core Objectives &",
    objectives_h2_2: "Philosophy",
    objectives_philosophy_label: "Our Philosophy",
    objectives_steps_label: "Procedure Execution Strategy",
    // Contact
    contact_label: "Get in Touch",
    contact_h2_1: "Let's Discuss Your",
    contact_h2_2: "Situation",
    contact_sub: "Leave us a message and our team will respond as soon as possible to discuss how we can assist you.",
    contact_name: "Full Name",
    contact_email: "Email Address",
    contact_company: "Company",
    contact_phone: "Phone",
    contact_subject: "Subject",
    contact_message: "Message",
    contact_submit: "Send Message",
    contact_success_title: "Message Sent",
    contact_success_sub: "Thank you for reaching out. We'll get back to you shortly.",
    contact_email_label: "Email",
    contact_phone_label: "Phone",
    contact_hq_label: "Headquarters",
    contact_offices_label: "Our Offices",
    contact_reg_label: "Registration",
    contact_reg_text: "Registered with UNPIR (National Union of Insolvency Practitioners in Romania) under number",
    contact_reg_date: ", dated 22.11.2024.",
    contact_ph_name: "Your full name",
    contact_ph_email: "your@email.com",
    contact_ph_company: "Company name",
    contact_ph_phone: "+40 ...",
    contact_ph_subject: "How can we help?",
    contact_ph_message: "Describe your situation...",
    contact_err_name: "Name is required",
    contact_err_email: "Email is required",
    contact_err_email_invalid: "Please enter a valid email",
    contact_err_message: "Message is required",
    // Footer
    footer_nav: "Navigation",
    footer_offices: "Offices",
    footer_contact: "Contact",
    footer_back_top: "Back to top",
    footer_rights: "All rights reserved.",
    footer_attestation: "Valid attestation through 31.12.2025",
    footer_tagline: "Insolvency Services & Consulting. Registered under UNPIR with number",
  },
  ro: {
    // Navigation
    nav_about: "Despre Noi",
    nav_services: "Servicii",
    nav_team: "Echip\u0103",
    nav_portfolio: "Portofoliu",
    nav_contact: "Contact",
    nav_contact_us: "Contacta\u021bi-ne",
    // Hero
    hero_label: "Servicii \u0219i Consultan\u021b\u0103 de Insolven\u021b\u0103",
    hero_h1_1: "Insolven\u021b\u0103",
    hero_h1_2: "Expertiz\u0103 &",
    hero_h1_3: "Solu\u021bii de \u00cencredere",
    hero_sub: "De peste un deceniu, ENSO SPRL este partenerul de \u00eencredere al companiilor aflate \u00een dificultate financiar\u0103, oferind o gestionare transparent\u0103 \u0219i eficient\u0103 a procedurilor de insolven\u021b\u0103.",
    hero_cta_services: "Serviciile Noastre",
    hero_cta_contact: "Contacta\u021bi-ne",
    hero_stat_years: "Ani de Experien\u021b\u0103",
    hero_stat_cases: "Dosare Gestionate",
    hero_stat_offices: "Loca\u021bii",
    hero_scroll: "Derula\u021bi",
    // About
    about_label: "Despre Noi",
    about_h2_1: "Peste un Deceniu de",
    about_h2_2: "Practic\u0103 de \u00cencredere",
    about_text: "ENSO SPRL este o societate profesional\u0103 cu r\u0103spundere limitat\u0103, constituit\u0103 conform dispozi\u021biilor OUG nr. 86/2006, av\u00e2nd ca obiect unic de activitate exercitarea profesiei de practician \u00een insolven\u021b\u0103.",
    about_extended: "Cu peste 15 ani de experien\u021b\u0103 \u00een insolven\u021b\u0103, ENSO SPRL a gestionat cu succes peste 1.500 de dosare la nivel na\u021bional. Echipa noastr\u0103 multidisciplinar\u0103, cu expertiz\u0103 vast\u0103 \u00een concordat preventiv, reorganizare judiciar\u0103 \u0219i proceduri de faliment, ne permite s\u0103 oferim clien\u021bilor solu\u021bii eficiente \u0219i personalizate, adaptate specificului fiec\u0103rui caz.",
    about_detail: "Activitatea noastr\u0103 acoper\u0103 numeroase sectoare de afaceri, iar noi avem o prezen\u021b\u0103 solid\u0103 \u00een principalele centre economice ale \u021b\u0103rii. Am dezvoltat \u00een timp o serie de mecanisme \u0219i procese aplicabile \u00een insolven\u021b\u0103, adaptate \u0219i grefate pe specificul fiec\u0103rei companii.",
    about_founders: "Parteneri Fondatori",
    about_formerly: "Anterior la",
    // Services
    services_label: "Serviciile Noastre",
    services_h2_1: "Solu\u021bii Complete de",
    services_h2_2: "Insolven\u021b\u0103",
    services_sub: "Oferim o gam\u0103 complet\u0103 de servicii de insolven\u021b\u0103, de la m\u0103suri preventive p\u00e2n\u0103 la proceduri complete de lichidare.",
    // Stats
    stats_label: "Indicatori Cheie",
    stats_h2: "Avantaje pentru",
    stats_h2_gold: "Creditori",
    // Team
    team_label: "Echipa Noastr\u0103",
    team_h2_1: "O Echip\u0103 Multidisciplinar\u0103",
    team_h2_2: "de Exper\u021bi",
    team_sub: "Echipa noastr\u0103 combin\u0103 decenii de experien\u021b\u0103 \u00een practic\u0103 de insolven\u021b\u0103, drept, contabilitate \u0219i tehnologie.",
    team_tab_practitioners: "Practicieni \u00een Insolven\u021b\u0103",
    team_tab_lawyers: "Avoca\u021bi \u0219i Juri\u0219ti",
    team_tab_support: "Personal de Suport",
    team_note: "Societatea profesional\u0103 dispune \u0219i de personal de secretariat \u0219i prelucrare documente pentru men\u021binerea eviden\u021belor documentare interne.",
    // Portfolio
    portfolio_label: "Portofoliu",
    portfolio_h2_1: "Dosare de Mare Complexitate",
    portfolio_h2_2: "Gestionate cu Succes",
    portfolio_sub: "Debitori cu grad ridicat de dificultate, gestiona\u021bi cu expertiz\u0103 \u0219i precizie pentru maximizarea recuper\u0103rii crean\u021belor.",
    portfolio_debts: "Datorii",
    portfolio_assets: "Active",
    // Objectives
    objectives_label: "Abordarea Noastr\u0103",
    objectives_h2_1: "Obiective \u0219i",
    objectives_h2_2: "Filosofie",
    objectives_philosophy_label: "Filosofia Noastr\u0103",
    objectives_steps_label: "Strategia de Derulare a Procedurii",
    // Contact
    contact_label: "Contacta\u021bi-ne",
    contact_h2_1: "S\u0103 Discut\u0103m",
    contact_h2_2: "Situa\u021bia Dumneavoastr\u0103",
    contact_sub: "L\u0103sa\u021bi-ne un mesaj \u0219i echipa noastr\u0103 v\u0103 va r\u0103spunde c\u00e2t mai cur\u00e2nd posibil pentru a discuta cum v\u0103 putem ajuta.",
    contact_name: "Nume Complet",
    contact_email: "Adres\u0103 de Email",
    contact_company: "Companie",
    contact_phone: "Telefon",
    contact_subject: "Subiect",
    contact_message: "Mesaj",
    contact_submit: "Trimite Mesaj",
    contact_success_title: "Mesaj Trimis",
    contact_success_sub: "V\u0103 mul\u021bumim c\u0103 ne-a\u021bi contactat. V\u0103 vom r\u0103spunde \u00een cel mai scurt timp.",
    contact_email_label: "Email",
    contact_phone_label: "Telefon",
    contact_hq_label: "Sediul Central",
    contact_offices_label: "Birourile Noastre",
    contact_reg_label: "\u00cenregistrare",
    contact_reg_text: "\u00cenregistrat\u0103 la UNPIR (Uniunea Na\u021bional\u0103 a Practicienilor \u00een Insolven\u021b\u0103 din Rom\u00e2nia) sub num\u0103rul",
    contact_reg_date: ", din data de 22.11.2024.",
    contact_ph_name: "Numele dumneavoastr\u0103 complet",
    contact_ph_email: "email@exemplu.com",
    contact_ph_company: "Numele companiei",
    contact_ph_phone: "+40 ...",
    contact_ph_subject: "Cu ce v\u0103 putem ajuta?",
    contact_ph_message: "Descrie\u021bi situa\u021bia dumneavoastr\u0103...",
    contact_err_name: "Numele este obligatoriu",
    contact_err_email: "Emailul este obligatoriu",
    contact_err_email_invalid: "Introduce\u021bi un email valid",
    contact_err_message: "Mesajul este obligatoriu",
    // Footer
    footer_nav: "Navigare",
    footer_offices: "Birouri",
    footer_contact: "Contact",
    footer_back_top: "\u00cenapoi sus",
    footer_rights: "Toate drepturile rezervate.",
    footer_attestation: "Atestat valabil p\u00e2n\u0103 la 31.12.2025",
    footer_tagline: "Servicii \u0219i Consultan\u021b\u0103 de Insolven\u021b\u0103. \u00cenregistrat\u0103 la UNPIR sub num\u0103rul",
  },
};
